import React from 'react';
import { SVGPureIcon } from '@/ui';
import InviteCodeListModal from '@src/components/modal/invite-code-list';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import CreateMcpModal from '@/components/modal/create-wcp';
import Tooltip from "@/ui/tooltip"
import { HelperCore } from '@/common/helper';

const InviteBtn = observer(({ className, small=false }) => {
  useEffect(() => {
    // 结果页会话，错误码400011时，链接跳转到首页 from=chat_invite，打开邀请码弹窗
    const urlParams = HelperCore.getParams();
    if (urlParams?.from === 'chat_invite') {
      InviteCodeListModal.show();
    }
    
    return () => {
      CreateMcpModal.close();
      InviteCodeListModal?.close?.();
    };
  }, []);

  return (
    <Tooltip title="邀请新用户，免费获得限免智能体（深度研究）使用次数">
      <div
        onClick={evt => {
          InviteCodeListModal.show();
        }}
        className={[
          'h-32px px-12px',
          'vh-center rounded-full mr-16px hover:bg-[#EAE1F7] cursor-pointer',
          'bg-[#F1E8FF]',
          small ? "px-5px" : "",
          className,
        ]}
      >
        <img 
          src="https://p5.ssl.qhimg.com/t110b9a9301fb42dddb8978108d.png" 
          className='size-22px'
        />
        {
          !small
          ? (
            <span className="text-black text-14px ml-6px whitespace-nowrap font-medium">
              邀请好友助力
            </span>
          )
          : null
        }
      </div>
    </Tooltip>
  );
});

export default InviteBtn;
